import { useCallback, useEffect, useState } from 'react';
import { api } from './api';
import { errorMessage } from './errors';

/** Carrega um recurso da API e recarrega quando o caminho muda (ou a cada `refreshMs`). */
export function useApi<T>(path: string | null, refreshMs?: number) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    if (!path) return;
    try {
      setData(await api.get<T>(path));
      setError(null);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setLoading(false);
    }
  }, [path]);

  useEffect(() => {
    setLoading(true);
    setData(null);
    void reload();
    if (!refreshMs) return;
    const t = window.setInterval(() => void reload(), refreshMs);
    return () => window.clearInterval(t);
  }, [reload, refreshMs]);

  return { data, error, loading, reload, setData };
}
